import React from 'react';
import {LoaderSection} from "../../../../../components/sections/loader/Loader";
import {useDeleteModal} from "../../../../../context/DeleteModalContext";
import {MODERATOR_QUESTION_CATEGORY} from "../../../../../mock/URLs";
import {EmptySection} from "../../../../../components/sections/empty/Empty";
import imgBaseUrl from "../../../../../utils/imgBaseUrl";

interface CategoryTableProps {
  questionCategory: any[];
  questionCategoryIsLoading: boolean;
  questionCategoryIsError: boolean;
  refetchQuestionCategory: () => void;
  handleEditClick: (id: number) => void;
}

const CategoryTable: React.FC<CategoryTableProps> = ({
                                                       questionCategory,
                                                       questionCategoryIsLoading,
                                                       questionCategoryIsError,
                                                       refetchQuestionCategory,
                                                       handleEditClick,
                                                     }) => {
  const {openDeleteModal} = useDeleteModal();

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_QUESTION_CATEGORY, id, refetchQuestionCategory);
  };

  return (
      <div className="card my-5">
        <div className="card-header">
          <h1 className="card-title">Mavjud turlar</h1>
        </div>
        <div className="card-body">
          {questionCategoryIsLoading ? (
              <LoaderSection height="20vh"/>
          ) : questionCategory?.length === 0 || questionCategoryIsError ? (
              <EmptySection height="20vh"/>
          ) : (
              <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300">
                  <thead>
                  <tr className="fw-bolder fs-6 text-gray-800">
                    <th>ID</th>
                    <th>Rasm</th>
                    <th>Nomi</th>
                    <th className="text-end">Amallar</th>
                  </tr>
                  </thead>
                  <tbody>
                  {questionCategory?.map((category) => (
                      <tr key={category.id}>
                        <td>{category.id}</td>
                        <td>
                          <img src={imgBaseUrl(category.image)} alt={category.name}
                               className="w-50px h-50px object-fit-cover"/>
                        </td>
                        <td>{category.name}</td>
                        <td className="text-end" style={{width: 'fit-content'}}>
                          <button className="btn btn-light-primary btn-sm me-2"
                                  onClick={() => handleEditClick(category.id)}>
                            O'zgartirish
                          </button>
                          <button onClick={() => handleDeleteClick(category.id)}
                                  className="btn btn-light-danger btn-sm">
                            O'chirish
                          </button>
                        </td>
                      </tr>
                  ))}
                  </tbody>
                </table>
              </div>
          )}
        </div>
      </div>
  );
};

export default CategoryTable;